import { useRef, useEffect, useState } from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link /*, useSearchParams*/ } from "react-router-dom";
import axios from "axios";
import arrow from "../../images/shapes/shape_arrow_right.svg";
import arrow2 from "../../images/shapes/shape_arrow_left.svg";
import icon1 from "../../images/icons/icon_calendar.svg";
import BlogSidebar from "../BlogSidebar";

const PAGE_SIZE = 5;

// Helpers
const stripHtml = (html) => {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  const text = div.textContent || div.innerText || "";
  return text.replace(/\s+/g, " ").trim();
};

const truncate = (text, limit = 150) => {
  if (!text) return "";
  if (text.length <= limit) return text;
  const sliced = text.slice(0, limit);
  const lastSpace = sliced.lastIndexOf(" ");
  return (lastSpace > Math.floor(limit * 0.8) ? sliced.slice(0, lastSpace) : sliced) + "...";
};

const formatDMY = (value) => {
  const d = new Date(value);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`https://api.rashtechinfo.com/getAllBlog`);
        setBlogs(Array.isArray(response.data) ? response.data : []);
        setCurrentPage(1);
      } catch (error) {
        console.log(error);
      }
    };
    fetchBlogs();
  }, []);

  // If you want to read page from URL on mount and on URL change:
  // useEffect(() => {
  //   const p = parseInt(searchParams.get("page") || "1", 10);
  //   setCurrentPage(Number.isNaN(p) || p < 1 ? 1 : p);
  // }, [searchParams]);

  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const totalPages = Math.ceil(blogs.length / PAGE_SIZE) || 1;
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const currentBlogs = blogs.slice(startIndex, startIndex + PAGE_SIZE);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    // If syncing with URL:
    // setSearchParams({ page: String(page) });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="blog_section section_space bg-light">
      <div className="container">
        {/* Hero Swiper for latest 3 posts */}
        <div className="blog_onecol_carousel overflow-hidden">
          <div className="swiper-wrapper">
            <Swiper
              modules={[Navigation]}
              spaceBetween={50}
              slidesPerView={1}
              loop={true}
              speed={1800}
              parallax={true}
              ref={swiperRef}
              onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
              }}
            >
              {blogs.slice(0, 3).map((blog, idx) => (
                <SwiperSlide key={blog._id || idx}>
                  <div className="blog_post_block content_over_layout">
                    <div className="blog_post_image">
                      <Link
                        onClick={ClickHandler}
                        to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                        className="image_wrap"
                      >
                        <img
                          src={`https://api.rashtechinfo.com//images/blogs/${blog.blog_image}`}
                          alt="Blog Post"
                          style={{ objectFit: "cover", width: "100%", height: "600px" }}
                        />
                      </Link>
                    </div>
                    <div className="blog_post_content">
                      <div className="post_meta_wrap">
                        <ul className="category_btns_group unordered_list">
                          {Array.isArray(blog.tags) && blog.tags.length > 0 ? (
                            blog.tags.map((tag) => (
                              <li key={tag}>
                                <Link
                                  onClick={ClickHandler}
                                  to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                                >
                                  {tag}
                                </Link>
                              </li>
                            ))
                          ) : (
                            <li>
                              <Link
                                onClick={ClickHandler}
                                to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                              >
                                Uncategorized
                              </Link>
                            </li>
                          )}
                        </ul>

                        <ul className="post_meta unordered_list">
                          <li>
                            <Link
                              onClick={ClickHandler}
                              to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                            >
                              <i className="fa-regular fa-calendar-days"></i>{" "}
                              {formatDMY(blog.createdAt)}
                            </Link>
                          </li>
                        </ul>
                      </div>

                      <h3 className="blog_post_title">
                        <Link
                          onClick={ClickHandler}
                          to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                        >
                          {blog.blog_title}
                        </Link>
                      </h3>

                      <p className="mb-0">
                        {truncate(stripHtml(blog.blog_content), 200)}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <button
            ref={prevRef}
            className="b1cc-swiper-button-prev"
            type="button"
            style={{ backgroundImage: `url(${arrow})` }}
          >
            <i className="fa-solid fa-angles-left"></i>
          </button>
          <button
            ref={nextRef}
            className="b1cc-swiper-button-next"
            type="button"
            style={{ backgroundImage: `url(${arrow2})` }}
          >
            <i className="fa-solid fa-angles-right"></i>
          </button>
          <div className="b1cc-swiper-pagination p-0"></div>
        </div>

        {/* Main list with pagination (5 per page) */}
        <div className="section_space pb-0">
          <div className="row">
            <div className="col-lg-8">
              {currentBlogs.map((blog) => (
                <div className="blog_post_block image_left_layout" key={blog._id}>
                  <div className="blog_post_image">
                    <Link
                      onClick={ClickHandler}
                      to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                      className="image_wrap"
                    >
                      <img
                        src={`https://api.rashtechinfo.com//images/blogs/${blog.blog_image}`}
                        alt="Blog Post"
                        style={{ objectFit: "cover", width: "100%" }}
                      />
                    </Link>
                  </div>

                  <div className="blog_post_content">
                    <div className="post_meta_wrap">
                      <ul className="category_btns_group unordered_list">
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                          >
                            {blog.category}
                          </Link>
                        </li>
                      </ul>

                      <ul className="post_meta unordered_list">
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                          >
                            <img src={icon1} alt="Icon Calendar" />{" "}
                            {formatDMY(blog.createdAt)}
                          </Link>
                        </li>
                      </ul>
                    </div>

                    <h3 className="blog_post_title">
                      <Link
                        onClick={ClickHandler}
                        to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                      >
                        {blog.blog_title}
                      </Link>
                    </h3>

                    <p>{truncate(stripHtml(blog.blog_content), 200)}</p>

                    <Link
                      onClick={ClickHandler}
                      to={`/blog/${blog.blog_title.replace(/\s+/g, "-")}`}
                      className="btn btn-dark"
                    >
                      <span className="btn_label" data-text="Read More">
                        Read More
                      </span>
                      <span className="btn_icon">
                        <i className="fa-solid fa-arrow-up-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              ))}

              {/* Dynamic pagination */}
              {totalPages > 1 && (
                <div className="pagination_wrap pb-0">
                  <ul className="pagination_nav unordered_list justify-content-center">
                    <li className={currentPage === 1 ? "disabled" : ""}>
                      <button
                        onClick={() => goToPage(currentPage - 1)}
                        aria-label="Previous page"
                        disabled={currentPage === 1}
                      >
                        <i className="fa-solid fa-angles-left"></i>
                      </button>
                    </li>

                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <li key={page} className={page === currentPage ? "active" : ""}>
                        <button
                          onClick={() => goToPage(page)}
                          aria-current={page === currentPage ? "page" : undefined}
                        >
                          {page}
                        </button>
                      </li>
                    ))}

                    <li className={currentPage === totalPages ? "disabled" : ""}>
                      <button
                        onClick={() => goToPage(currentPage + 1)}
                        aria-label="Next page"
                        disabled={currentPage === totalPages}
                      >
                        <i className="fa-solid fa-angles-right"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <BlogSidebar />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogList;
